import React from 'react';
import { Menu, Layout, Tooltip } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router';
import RouteSetting from '../../RouteSetting';
import css from './Menus.less';
import { ShouqiIcon } from './ShouqiIcon';
import { ZhankaiIcon} from './ZhankaiIcon';
import { A } from './A';
import { observer } from 'mobx-react';
import { menuCollapsedStore, sideState, sideStateMap, STORE_SIDE_STATE_NAME } from '../menuStatusStore';

const {Divider} = Menu;
export interface IMenus {
    router: RouteSetting;
    extraFooter?: React.ReactNode;
    menuClick?: (menuName: string | undefined) => void;
}

// 左侧导航的宽度
enum LeftMenuWidth {
    expand = 200,
    unexpand = 60,
}

/**
 * 获取展开的菜单
 */
let openKeys: string[] = [];
export function setOpenKeys(keys: string[]) {
    openKeys = keys;
}
function getOpenKeys(): string[] {
    return openKeys;
}

// 设置左侧默认折起方法
let set_default_collapsed_handlers: (() => boolean | undefined) | null = null;
export function setDefaultCollapsed(handler: () => boolean | undefined) {
    set_default_collapsed_handlers = handler;
}

function restoreCollapseState() {
    const val = localStorage.getItem(STORE_SIDE_STATE_NAME);
    return val ? sideStateMap[val] : sideStateMap[sideState.open];
}

function getCollapseState() {
    if (set_default_collapsed_handlers) {
        const collapeds = set_default_collapsed_handlers();
        if (collapeds !== undefined) {
            return collapeds;
        }
    }
    return restoreCollapseState();
}

function getRouteObj(pathname, router: RouteSetting) {
    if (!router.routeSettings) {
        return;
    }
    let routeObj = router.routeSettings.find(
        item => item.path === pathname || pathname.includes(item.menuKey)
    );

    if (!routeObj) {
        router.routeSettings.some(item => {
            routeObj = getRouteObj(pathname, item);
            return !!routeObj;
        });
    }
    return routeObj;
}
/**
 * 获取选中的菜单key
 * @param pathname
 * @param router
 */
function getMenuSelectedKeys(pathname, router: RouteSetting) {
    const routeObj = getRouteObj(pathname, router);
    return routeObj?.selectMenuKey || routeObj?.menuKey || pathname;
}

function renderRouteSetting(router: RouteSetting, menuClick?: (menuName?: string) => void): React.ReactNode {
    if (router.forbiddenMenu) {
        return null;
    }

    const hanldeClickMenu = (menuName?: string) => {
        menuClick?.(menuName);
    }

    const title = (
        <span className={ css.icon }>
            { router.iconType /* 此处不要包裹标签，会导致 菜单 收缩显示错误 */ }
            <span>{ router.title }</span>
        </span>
    );
    if (!router.routeSettings) {

        if (router.type === 'group-divide') {
            if ( !getCollapseState()) {
                const arr = [<Menu.Divider />];
                if (router.title ) {
                    arr.push(<Menu.ItemGroup title={ router.title }/>);
                }
                return arr;
            }
            return null;
        }

        if (router.type === 'group') {
            if (!menuCollapsedStore.collapsed) {
                const arr: any[] = [];
                if (router.title) {
                    arr.push(<Menu.ItemGroup title={router.title} />);
                }
                return arr;
            }
            return null;
        }

        return (
            <Menu.Item key={ router.getMenuKey() } data-ui-test-info={`menu-(${router.title})`}>
                <A path={router.path}
                   dynamicPath={ router.dynamicPath?.(router) }
                   style={{color: 'unset'}}
                   params={router.getQsFields()}
                   onClick={() => hanldeClickMenu(router.title)}
                >
                    { title}
                </A>
            </Menu.Item>
        );
    }
    if (router.isRoot) {
        return router.routeSettings.map(it => renderRouteSetting(it, menuClick));
    }

    return (
        <Menu.SubMenu title={ title } key={ router.getMenuKey() }>
            {
                router.routeSettings.map(it => renderRouteSetting(it, menuClick))
            }
        </Menu.SubMenu>
    );
}

@observer
class LayoutSider extends React.Component<IMenus & RouteComponentProps, any> {
    // defatult collapsed = false 展开状态
    public state = {
        openKeys: getCollapseState() ? [] : getOpenKeys()
    };

    constructor(props) {
        super(props);
        menuCollapsedStore.setDefaultValue(getCollapseState());
        // 没懂为啥要写下面的代码
        // props.history.listen((location) => {
        //     // default collapse = true 关闭状态
        //     menuCollapsedStore.changeCollapsed(getCollapseState());
        // });
    }

    public onClick = (args: any) => {
        this.props.history.push(args.key);
    }

    // this.state.openKeys 受控
    public changeOpenKey = (keys) => {
        this.setState({
            openKeys: keys
        });
        if (keys.length > 0) {
            setOpenKeys(keys); // 借助openKeys存储用户展开的菜单
        }
    }

    // 该方法会调用changeOpenKey修改openKeys，收起时调用this.changeOpenKey([])，
    // 导致用户展开的菜单，在折叠又打开sider后，全部收起
    public toggleIcon = () => {
        const state = !menuCollapsedStore.collapsed;
        if (state) {
            setOpenKeys(this.state.openKeys); // 借助openKeys存储用户展开的菜单
        }
        if (menuCollapsedStore.collapsed) {
            this.setState({
                openKeys: getOpenKeys() // 展开后给this.state.openKeys重新赋值
            });
        }
        menuCollapsedStore.changeCollapsed(state);
    }
    public render() {
        return (
            <Layout.Sider
                collapsed={menuCollapsedStore.collapsed }
                theme={ 'light' }
                className={ `${ css.mainLayoutSider } mainLayoutSider` }
                width={ menuCollapsedStore.collapsed ? LeftMenuWidth.unexpand : LeftMenuWidth.expand }
            >
                <div className={ css.menuBox }>
                    <Menu
                        onOpenChange={ this.changeOpenKey }
                        openKeys={ this.state.openKeys }
                        // expandIcon={<CaretDownOutlined />}
                        selectedKeys={ [getMenuSelectedKeys(this.props.location.pathname, this.props.router)] }
                        mode={ 'inline' }
                        className={ `${ css.menu } mainLayoutSiderMenue` }
                    >
                        {
                            renderRouteSetting(this.props.router, this.props.menuClick)
                        }
                    </Menu>
                    <div className={ css.menuIconBox }
                    style={{
                        width: menuCollapsedStore.collapsed
                        ? (LeftMenuWidth.unexpand + 'px')
                        : (LeftMenuWidth.expand + 'px')
                    }}>
                        {this.props.extraFooter}
                        <div onClick={ this.toggleIcon } className={ css.collapseIcon }>
                        {
                            menuCollapsedStore.collapsed
                            ? <Tooltip title="展开导航"><ZhankaiIcon className={ css.menuIcon } /></Tooltip>
                            : <Tooltip title="收起导航"><ShouqiIcon className={ css.menuIcon } /></Tooltip>
                        }
                        </div>
                    </div>
                </div>
            </Layout.Sider>
        );
    }
}

const Menus = withRouter(LayoutSider);

export default Menus;
